import { Outlet } from 'react-router-dom';

import Nav from '@App/components/Nav/Nav';
import Welcome from '@App/components/Welcome/Welcome';

import './nav-wrapper.css';

function NavWrapper() {
  return (
    <div className="nav-wrapper">
      <Nav />
      <Outlet />
      <Welcome />
    </div>
  );
}

export default NavWrapper;
